import React, {useState, useEffect} from "react";
import ResetPopupImg from "../Assets/ResetPopup.png";

const FinalApiConfirmationPopup = ({setShowFinalApiCallPopup, SubmitSchedule, isSubmitting}) => {

  const closePopup = () =>{
      console.log("Close icon clicked");
      setShowFinalApiCallPopup(false);
  }
  
    return (
      <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg w-[340px] lg:w-[370px]">
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={closePopup}
              />
            </div>

            <div  className="mt-[-120px] flex w-full justify-center items-center">
              <img
                src={ResetPopupImg}
                alt="img"
              />
            </div>

          <h2
            className=" mb-2 text-center text-[16px]"
          >
            Schedule Confirmation
          </h2>
          <p className="text-center text-[14px]">Are you sure, You have finalized the schedule for the student?</p>
          
          <div className="w-full flex flex-col ustify-center items-center gap-[15px] mt-[15px]">
            <button
                className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={SubmitSchedule} // ✅ Call confirm handler
                style={{border:"2px solid #A1A3EF"}}>
                  {isSubmitting ? 'Submitting...' : 'Submit Schedule'}
            </button>

            <p className="text-[14px] text-center cursor-pointer" onClick={closePopup}>Edit</p>
          </div>
        </div>
      </div>
    );
  };

export default FinalApiConfirmationPopup;
